import React, { Component } from "react";
import axios from "../config/axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, ProgressBar, Row } from "react-bootstrap";
// import _ from "lodash";
import ToggleButton from 'react-toggle-button'
import { Header, HeaderLogout, HeaderTop } from "../components/headers";
import { FooterLink } from "../components/footers";
import {
  Bio,
  Blog,
  Contact,
  Home,
  Resources,
  Testimonial,
} from "../views/coachprofileprivate";

import BookSession from '../views/coach/view/BookSession'

import { avatar } from "../assets/img";
import {
  mailSvg,
  profileAddressSvg,
  flagSvg,
  clockSvg,
  writingSvg,
  quality
} from "../assets/images";
import {
  UpdateImage,
  UpdatePersonal,
  UpdateUserName,
  UpdateCategory,
} from "../views/coach/edit";
// import CommunicationUsers from "./Communication/CommunicationUsers";

class CoachProfilePrivate extends Component {

  constructor(props, context) {
    super(props, context);
    this.token = localStorage.getItem("authToken");

    // if (localStorage.getItem("userdata")) {
    //   this.userdata = JSON.parse(localStorage.getItem("userdata"));
    // } else {
    //   if (this.props.location.state !== "undefined") {
    //     this.userdata = {
    //       account_type: "user",
    //       uid: this.props.location.state.coachData.uid,
    //     };
    //   } else {
    //     alert("please Login for more details.");
    //   }
    // }

    if (localStorage.getItem("user")) {
      this.userdata = JSON.parse(localStorage.getItem("user"));
    }

    else if (this.props.location !== undefined) {
      let path = window.location.href.split('/');
      let Public_view_uid = path[path.length - 1]
      this.userdata = {
        account_type: "user",
        uid: Public_view_uid,
      };
    }

    else if (localStorage.getItem("userdata")) {
      this.userdata = JSON.parse(localStorage.getItem("userdata"));
    }


    else {
      // #temprary if page will refereshed by mistake
      this.userdata = {
        account_type: "user",
        uid: "44abb6bc-8361-4a56-a88a-3b4c8b10eea2",
      };
    }

    // this.coachingType = [];

    this.state = {
      eligibleForContact: false,
      coachprofileimage: avatar,
      freeTrialDaysleft: "",
      renderSubComponent: "Home",
      avatar: "",
      avatar_path: avatar,
      name: "",
      coach_title: "",
      user_title: "",
      // coach_category: "",
      // coaching_category: "",
      city: "",
      email: "",
      country: "",
      location: "",
      userImage: "",
      coach_uid: "",
      short_bio: "",
      long_bio: "",
      videofile: "",
      tags: "",
      skills: "",
      isLoaded: "",
      coachprofile_id: "",
      check_account_type: "",
      // dounat chart value using this___start
      chartValue: [],
      labels_data: [],
      data_data: [],
      color_data: [],
      // dounat chart value using this____end
      // coaching_category_list: [],
      language: [{ value: "English", label: "English" }],
      timezone: "",
      HoursofExp: "",
      HourlyRate: "",
      membership: 0,
      alertMsg: "",

      baseCurrency: "USD",
      convertToCurrency: "USD",
      baseAmount: 100,
      rates: [],
      currencies: [],
      findcurrency: 1,
      totalprofileupdate: "",
      tag_update_profile: 0,
      avatar_path_update_profile: 0,
      user_title_update_profile: 0,
      short_bio_update_profile: 0,
      packages_update_profile: 0,
      coachingCategory: null,
      coachUid: "",
      coachEmail: "",
      Consumer_name: "",
      Consumer_email: "",
      SocialMediaInfo: [{ SocialMedia: "", URL: "" }],
      public_profile_toggle: false,
      isApproved: 0,
      Public_view_username: "",
      Public_view_uid: "",
      showLoader: true,
      userd: null,
      coachSettings: "",
      city_public: 0,
      processed: '',
    };
  }


  componentDidMount() {
    this.handlepublicview();
    this.isBookedMainsessionWithCoach()


    this.callAPI(this.state.baseCurrency);
    this.getSettings();
    if (this.userdata.account_type === "coach") {
      this.setState({ check_account_type: "coach" });
      this.coachMode();
      this.handleFunction();
    } 
    // else if (this.props.location.state !== undefined) {
    //   if (this.props.location.state.coachData.account_type === "coach") {
    //     // this.setState({ check_account_type: "consumer" });
    //     // this.consumerMode();
    //   } else {
    //     console.log("visitor");
    //   }
    // } 
    else {
      console.log("visitor, localstorage data can not read");
    }
    this.getconsumersinfo()

  }

  isBookedMainsessionWithCoach = () => {
    let path = window.location.href.split('/');
    let coachuid = path[path.length - 1]
    //if (coachuid === null || coachuid === undefined) return;
    console.log('coachuid', coachuid);
    let consumerData = JSON.parse(localStorage.getItem('userdata'));
    console.log("yes entered the required function", consumerData.uid, coachuid)
    if (coachuid === null || coachuid === undefined || consumerData === null || consumerData === undefined) return;
    let formData = {
      coachuid: coachuid,
      useruid: consumerData.uid
    }

    axios
      .post("users/isbooked-main", formData)
      .then((res) => {
        console.log("walla",res)
        if(res.data.success) {
          this.setState({eligibleForContact: true})
        }
        else {
          console.log("err")
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }


  getconsumersinfo = async () => {
    let uid = localStorage.getItem('userdata');
    if (uid !== undefined || uid !== null) {
      uid = uid != null ? JSON.parse(uid).uid : ''
      await axios.post('/users/fetchconsumersdata', { uid: uid }).then((res) => {
        //console.clear();
        console.log('res', uid);

        console.log('res', res);
        if (res.data.success === true && res.data.value.length > 0) {
          if (res.data.value[0].avatar_path !== null && res.data.value[0].avatar_path !== '' && res.data.value[0].avatar_path !== undefined) {
            this.setState({ coachprofileimage: res.data.value[0].avatar_path });
          }

        }
      }).catch((err) => {
        console.log('err', err)
      })
    }

  }

  handlepublicview() {
    let userdata = JSON.parse(localStorage.getItem('userdata'));
    if (userdata == undefined) {
      let hrefValue = window.location.href
      let visitedCoach = hrefValue.split('/').pop()
      localStorage.setItem('afterLoginHref', visitedCoach)
      this.props.history.push('/login')
    } else {
      if (userdata !== null && userdata !== undefined) {

        console.log('userdata'.userdata)
        if (userdata.account_type === 'user') {
          this.setState({ userd: { name: userdata.name, email: userdata.email, uid: userdata.uid } })
        }
      }
    }

    console.log('enter ');
    let path = window.location.href.split('/');
    console.log('pathhh', path)
    this.setState({ Public_view_username: path[path.length - 2], Public_view_uid: path[path.length - 1] });
    this.fetchcoachpublicApi();

  }


  fetchcoachpublicApi = async () => {
    let self=this
    let path = window.location.href.split('/');
    let Public_view_uid = path[path.length - 1]
    if (Public_view_uid === undefined || Public_view_uid === null) return;

    await axios.post('/users/fetchcoachpublic', { uid: Public_view_uid }).then((res) => {
      this.setState({ showLoader: false });
      if (res.data.success === true) {
        // this.props.location.state.coachData = res.data.value[0]
       let rawdata= res.data.value[0]
        this.setState({ check_account_type: "consumer" });
        console.log('profileeeeeeeeeeeeeeeeeeeee',res.data.value[0])
        this.setState({
          coachingCategory: rawdata.coaching_category
              ? JSON.parse(rawdata.coaching_category)
              : "",
              membership: rawdata.has_membership,
              city_public: rawdata.city_public,
              user_title: rawdata.user_title,
        })
        self.consumerMode(res.data.value[0], Public_view_uid);

      } else {
        alert('something went wrong')
      }
      console.log('res', res);


    }).catch((err) => {
      console.log('err', err)
    })


  }

  coachMode() {
    this.profileUpdateStatus();
    this.fetchUserName();
    this.fetchCoachData();
    this.handleFunction();
    this.getPackages();
  }

  consumerMode(rawdata, uid) {
    console.log('rawdataaaaaaaaaaaaaaaaaaaaaaaaa', rawdata)
    // const rawdata = this.props.location.state.coachData;
    // console.log('rawwwwwwwwwwwwww' , rawdata)
    // let Consumer_name = this.props.location.state.Consumer_name
    console.log(rawdata);
    this.setState({
      name: rawdata.name,
      coachEmail: rawdata.email,
      coaching_category: rawdata.coaching_category,
      coach_title: rawdata.coach_title,
      coachUid: uid,
      Consumer_uid: 'this.props.location.state.Consumer_uid',
      Consumer_name: 'Consumer_name',
      Consumer_email: 'this.props.location.state.Consumer_email',
      blog_id:rawdata.blog_id,
    });
    this.updateStateData(rawdata);
   
  }
  // consumerMode() {
  //   const rawdata = this.props.location.state.coachData;
  //   let Consumer_name = this.props.location.state.Consumer_name
  //   console.log(rawdata);
  //   this.setState({
  //     name: rawdata.name,
  //     coachEmail: rawdata.email,
  //     coaching_category: rawdata.coaching_category,
  //     coach_title: rawdata.coach_title,
  //     coachUid: rawdata.uid,
  //     Consumer_uid: this.props.location.state.Consumer_uid,
  //     Consumer_name: Consumer_name,
  //     Consumer_email: this.props.location.state.Consumer_email
  //   });
  //   this.updateStateData(rawdata);
  // }

  updateStateData = (rawdata) => {
    const rawaddress = rawdata.address ? JSON.parse(rawdata.address) : "";
    // const rawskills = rawdata.skills ? JSON.parse(rawdata.skills) : "";

    this.setState({
      totalprofileupdate: rawdata.profile_completed_percent,
      userImage: rawdata.avatar_path,
      coach_uid: rawdata.coach_uid,
      short_bio: rawdata.short_bio,
      // long_bio: rawdata.long_bio,
      long_bio:
        rawdata.long_bio !== undefined ? rawdata.long_bio : "loading...",

      videofile: rawdata.profile_video,
      processed: rawdata.processed,
      avatar_path: rawdata.avatar_path ? rawdata.avatar_path : avatar,
      country: rawaddress.country,
      location: rawaddress.location,
      city: rawaddress.city,
      coachprofile_id: rawdata.uid,
      tags: rawdata.tags,
      skills: rawdata.skills ? JSON.parse(rawdata.skills) : "",
      // tag_update_profile: 0,
      // avatar_path_update_profile: 0,
      // short_bio_update_profile: 0,
      // packages_update_profile: 0,

      language: rawdata.language ? JSON.parse(rawdata.language) : "",
      timezone: rawdata.timezone,
      HoursofExp: rawdata.hours_of_experience,
      HourlyRate: rawdata.hourly_rate,
      membership: rawdata.has_membership,
      city_public: rawdata.city_public,
      wordcount:
        rawdata.short_bio && parseInt(rawdata.short_bio.split(" ").length),
      SocialMediaInfo: rawdata.social_media !== null ? (JSON.parse(rawdata.social_media)) : ([{ SocialMedia: "", URL: "" }]),
      public_profile_toggle: rawdata.isPublic ? rawdata.isPublic : false
    });
  };

  // ____________________________Fetch_data___________________________________

  getSettings() {
    console.log('fetch public package')

    axios
      .get("/users/settings-for-coach", {
        // headers: {
        //   "X-Auth": this.token,
        // },
      })
      .then(async(res) => {
        await this.setState({ coachSettings: JSON.parse(res.data.value.tagsAndTimes[0].content) });
        //console.log("found new data for coach settings--------------[][]][][][][][----", this.state.coachSettings)
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchUserName() {
    let self = this;
    let param = {
      url: "/users/username",
      method: "GET",
      headers: {
        "X-Auth": this.token,
      },
    };
    axios(param)
      .then(async (res) => {
        if (res.data.value) {
          const rawdata = res.data.value;

          console.log('cateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',rawdata)
          self.setState({
            name: rawdata.name,
            // coaching_category: rawdata.coaching_category,
            user_title: rawdata.user_title,
            coachingCategory: rawdata.coaching_category
              ? JSON.parse(rawdata.coaching_category)
              : "",
          });
          this.setState({
            user_title_update_profile: 0,
          });
          if (this.state.user_title && this.state.user_title.length > 0) {
            this.setState({
              user_title_update_profile: 20,
            });
          }
          this.profileUpdateStatus();
        }
      })
      .catch((error) => {
        console.log(error);
        toast("Error getting User data", { type: "error" });
      });
  }

  fetchCoachData() {
    const id = this.userdata.uid;

    let param = {
      url: `/users/coachprofile/${id}`,
      method: "GET",
      headers: {
        "X-Auth": this.token
      }
    }
    axios(param)
      .then(async (res) => {
        console.log("-------------------------------------------res-socail-------------", res.data.value)
        if (res.data.value) {

          //console.clear();
          console.log("coach data", res.data.value)

          const rawdata = res.data.value;
          // const rawaddress = rawdata.address ? JSON.parse(rawdata.address) : "";
          const rawskills = rawdata.skills ? JSON.parse(rawdata.skills) : "";
          this.setState({ chartValue: rawskills });
          this.setState({ isApproved: rawdata.is_approved })

          if (rawskills.length > 1) {
            await this.setState({
              chartValue: rawskills,
              isLoaded: true,
            });
          } else {
            this.setState({ isLoaded: false });
          }
          this.updateStateData(rawdata);

          if (this.state) {
            if (this.state.avatar_path !== avatar) {
              this.setState({ avatar_path_update_profile: 20 });
            }
            if (this.state.short_bio.length > 2) {
              this.setState({ short_bio_update_profile: 20 });
            }

            // if (this.state.short_bio.length > 2) {
            //   this.setState({ packages_update_profile: 20 });
            // }

            if (this.state.tags.length > 2) {
              this.setState({ tag_update_profile: 20 });
            }
          }

          this.profileUpdateStatus();
          this.dountChartUpdated();
        }
      })
      .catch((error) => {
        console.log("fetch error");
        console.log(error);
        // toast("Error getting profile data", { type: "error" });
      });
  }

  getPackages() {
    const id = this.userdata.uid;
    axios
      .get(`/users/packages/${id}`, {
        headers: {
          "X-Auth": this.token,
        },
      })
      .then((res) => {
        if (res.data.success) {
          let pack = res.data.value;
          if (pack.length > 0) {
            this.setState({ packages_update_profile: 20 });
            this.profileUpdateStatus();
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  packagefound = () => {
    this.setState({ packages_update_profile: 20 });
    this.profileUpdateStatus();
  };
  // ____________________________Handle_Function_______________________________

  handleChangeMultiSkills = (e) => {
    const index =
      this.state.chartValue.length > 0
        ? this.state.chartValue.indexOf(e.target.id)
        : -1;

    if (e.currentTarget.checked) {
      if (index === -1) {
        if (this.state.chartValue.length < 4) {
          this.setState({
            chartValue: [...this.state.chartValue, e.target.id],
          });
        } else {
          toast("You can add maximum 4 styles", { type: "error" });
        }
      }
    }
    if (!e.currentTarget.checked) {
      this.setState({
        chartValue: [
          ...this.state.chartValue.filter((element) => element !== e.target.id),
        ],
      });
    }
  };

  handleSubComponent = (cname) => {
    this.setState({ renderSubComponent: cname });
  };

  handleChange = (e) => {
    e.persist();
    if (e.target.name === "short_bio") {
      let limit = 50 - parseInt(e.target.value.split(" ").length);
      let ro = e.target.value.split(" ").length > 50 ? true : false;
      let msg =
        e.target.value.split(" ").length > 50
          ? "Short bio word limit exceeded"
          : "";
      this.setState({ wordcount: limit, alertMsg: msg, readonly: ro });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // this is for long bio text
  handleOnChange = (event, editor) => {
    const data = editor.getData();
    this.setState({
      long_bio: data,
    });
  };

  handlegetProfileVideo = () => {
    this.fetchCoachData();
  };
  handlegetProfileImage = () => {
    this.fetchCoachData();
  };
  handleSubmitProfileVideo = () => {
    this.fetchCoachData();
  };
  onChangeHandler = (e) => {
    this.setState({
      avatar_path_temp: e.target.files[0],
      loaded: 0,
    });
  };

  handleAddressSelected = (address, country, city) => {
    this.setState({ country: country, city: city, location: address });
  };

  handleLanguageChange = (language) => {
    this.setState({ language: language });
  };

  handleCategoryChange = (data) => {
    this.setState({ coachingCategory: data });
  };

  handleCheckbox = (e) => {
    if (e.target.value == 0) {
      this.setState({ membership: 1 });
    } else if (e.target.value == 1) {
      this.setState({ membership: 0 });
    }
  };

  changeConvertToCurrency = (e) => {
    this.setState({
      convertToCurrency: e.target.value,
    });
    const ps = this.state.rates[this.state.convertToCurrency];
    console.log("currency----", this.state.rates)
    console.log("currency----", this.state.rates[this.state.convertToCurrency])
    console.log("psssss---------", ps)
    this.setState({ findcurrency: ps });
  };

  handleFunction = () => {
    const accontCreated = new Date(this.userdata.created);
    const finalDate = new Date(accontCreated);
    finalDate.setDate(accontCreated.getDate() + 90);
    var countDownDate = new Date(finalDate);
    var now = new Date();
    var timeleft = countDownDate - now;
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    this.setState({
      freeTrialDaysleft: days >= 0 ? days : 0,
    });
  };

  profileUpdateStatus() {
    this.setState({ totalprofileupdate: 0 });
    const totalProfile =
      parseInt(this.state.avatar_path_update_profile) +
      parseInt(this.state.user_title_update_profile) +
      parseInt(this.state.short_bio_update_profile) +
      parseInt(this.state.tag_update_profile) +
      parseInt(this.state.packages_update_profile);
    this.setState({ totalprofileupdate: totalProfile });
    this.totalProfileUpdateStatus()
  }

  totalProfileUpdateStatus() {
    const id = this.userdata.uid;
    let formData = { percentData: this.state.totalprofileupdate }

    let param = {
      url: `/users/complete-status/${id}`,
      method: "POST",
      data: formData,
      headers: {
        "X-Auth": this.token
      }
    }
    axios(param)
      .then((response) => {
        //toast("Coaching style added successfully", { type: "success" });
        console.log("response")
      })
      .catch((error) => {
        console.log(error);
        //toast("Error in updating", { type: "error" });
      });
  }

  callAPI(base) {
    const api = `https://api.exchangeratesapi.io/latest?base=${base}`;

    fetch(api)
      .then((results) => {
        return results.json();
      })
      .then((data) =>
      console.log('dd')
        //this.setState({
          //rates: data["rates"],
          //currencies: Object.keys(data["rates"]).sort(),
        //})
      );
  }

  dountChartUpdated() {
    var skillName = [];
    var skillvalue = [];
    var skillcolor = [];

    // ["red##25##redSkill2", "yellow##25##yelloSkill3"]

    if (this.state.chartValue.length > 0) {
      this.state.chartValue.map((item) => {
        skillcolor.push(item.split("##")[0]);
        skillvalue.push(parseInt(item.split("##")[1]));
        skillName.push(item.split("##")[2]);
      });
    }

    this.setState({
      labels_data: skillName,
      data_data: skillvalue,
      color_data: skillcolor,
    });
  }

  // ____________________________Handle_Function_submit______________________________

  // handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (this.state.short_bio && this.state.short_bio.split(" ").length > 50) {
  //     toast("Word limit exceeded for short bio", {
  //       type: "error",
  //     });
  //   } else {
  //     const addressData = {
  //       country: this.state.country,
  //       city: this.state.city,
  //       location: this.state.location,
  //     };
  //     const formData = {
  //       address: JSON.stringify(addressData),
  //       short_bio: this.state.short_bio,
  //       coach_uid: this.state.coach_uid,
  //       long_bio: this.state.long_bio,
  //       skills: JSON.stringify(this.state.chartValue),
  //       language: this.state.language,
  //       timezone: this.state.timezone,
  //       HoursofExp: this.state.HoursofExp,
  //       HourlyRate: this.state.HourlyRate,
  //       membership: this.state.membership,
  //     };
  //     let param;
  //     if (this.state.coachprofile_id !== "") {
  //       formData["uid"] = this.state.coachprofile_id;
  //       param = {
  //         url: "/users/coachprofile",
  //         method: "PUT",
  //         data: formData,
  //         headers: {
  //           "X-Auth": this.token,
  //         },
  //       };
  //     } else {
  //       param = {
  //         url: "/users/coachprofile",
  //         method: "POST",
  //         data: formData,
  //         headers: {
  //           "X-Auth": this.token,
  //         },
  //       };
  //     }

  //     axios(param)
  //       .then((response) => {
  //         toast("Personal details updated", {
  //           type: "success",
  //         });

  //         const rawdata = response.data.profilePost;
  //         const rawaddress = rawdata.address ? JSON.parse(rawdata.address) : "";
  //         const rawskills = rawdata.skills ? JSON.parse(rawdata.skills) : "";

  //         if (rawskills.length > 0) {
  //           this.setState({
  //             chartValue: rawskills,
  //             isLoaded: true,
  //           });
  //         } else {
  //           this.setState({
  //             isLoaded: false,
  //           });
  //         }

  //         this.setState({
  //           userImage: rawdata.avatar_path,
  //           coach_uid: rawdata.coach_uid,
  //           short_bio: rawdata.short_bio,

  //           long_bio:
  //             rawdata.long_bio !== undefined
  //               ? rawdata.long_bio
  //               : this.state.responseData.profilePost.long_bio,

  //           videofile: rawdata.profile_video,
  //           country: rawaddress.country,
  //           location: rawaddress.location,
  //           city: rawaddress.city,
  //           coachprofile_id: rawdata.uid,
  //           isUpdate: true,
  //           showLoader: false,

  //           language: rawdata.language,
  //           timezone: rawdata.timezone,
  //           HoursofExp: rawdata.hours_of_experience,
  //           HourlyRate: rawdata.hourly_rate,
  //           membership: rawdata.has_membership,
  //         });
  //         this.setState({
  //           short_bio_update_profile: 0,
  //         });

  //         if (this.state.short_bio.length > 5) {
  //           this.setState({
  //             short_bio_update_profile: 20,
  //           });
  //         }

  //         this.setState({
  //           user_title_update_profile: 0,
  //         });
  //         if (this.state.user_title && this.state.user_title.length > 0) {
  //           this.setState({
  //             user_title_update_profile: 20,
  //           });
  //         }

  //         this.profileUpdateStatus();

  //         toast("Personal details updated", {
  //           type: "success",
  //         });
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         toast("Error in updating details", {
  //           type: "error",
  //         });
  //       });
  //   }
  // };

  handleResourceSubmit = (flag) => {
    this.setState({ showLoader: flag });
  };

  handleSubmitSkill = (e) => {
    e.preventDefault();

    const addressData = {
      country: this.state.country,
      city: this.state.city,
      location: this.state.location,
    };

    const formData = {
      address: JSON.stringify(addressData),
      short_bio: this.state.short_bio,
      coach_uid: this.state.coach_uid,
      long_bio: this.state.long_bio,
      skills: JSON.stringify(this.state.chartValue),
      name: this.state.name,

      language: this.state.language,
      timezone: this.state.timezone,
      HoursofExp: this.state.HoursofExp,
      HourlyRate: this.state.HourlyRate,
      membership: this.state.membership,
    };

    let param;
    if (this.state.coachprofile_id !== "") {
      formData["uid"] = this.state.coachprofile_id;
      param = {
        url: "/users/coachprofile",
        method: "PUT",
        data: formData,
        headers: {
          "X-Auth": this.token,
        },
      };
    } else {
      param = {
        url: "/users/coachprofile",
        method: "POST",
        data: formData,
        headers: { "X-Auth": this.token },
      };
    }

    axios(param)
      .then((response) => {
        toast("Coaching style added successfully", { type: "success" });

        this.fetchCoachData();
        this.dountChartUpdated();
      })
      .catch((error) => {
        console.log(error);
        toast("Error in updating", { type: "error" });
      });
  };

  handleSubmitProfileImage = (e) => {
    this.setState({ showLoader: true });
    e.preventDefault();
    const formData = new FormData();
    formData.append("avatar_path", this.state.avatar_path_temp);

    let param;
    if (this.state.coachprofile_id !== "") {
      formData["uid"] = this.state.coachprofile_id;
      param = {
        url: "/users/profileimage",
        method: "PUT",
        data: formData,
        headers: {
          "X-Auth": this.token, //this.props.location.state.token,
          "Content-type": "multipart/form-data",
        },
      };
    } else {
      param = {
        url: "/users/profileimage",
        method: "POST",
        data: formData,
        headers: {
          "X-Auth": this.token, //this.props.location.state.token,
          "Content-type": "multipart/form-data",
        },
      };
    }

    axios(param)
      .then((response) => {
        if (response.data.success) {
          this.setState({
            avatar_path: response.data.profileImagePost.avatar_path,
            showLoader: false,
            avatar_path_temp: null,
            avatar_path_update_profile: 20,
          });
          toast("Image updated", { type: "success" });
          this.profileUpdateStatus();
          this.fetchCoachData();
        }
      })
      .catch((error) => {
        console.log("photo update error");
        console.log(error);
        toast("Error in updaing profile image", { type: "error" });
        this.setState({
          showLoader: false,
        });
      });
  };

  handleUpdateTags = (formData) => {
    let param;
    if (this.state.coachprofile_id !== "") {
      param = {
        url: "/users/tags",
        method: "PUT",
        data: formData,
        headers: {
          "X-Auth": this.token,
        },
      };
    } else {
      param = {
        url: "/users/coachprofile-edit",
        method: "POST",
        data: formData,
        headers: { "X-Auth": this.token },
      };
    }
    axios(param)
      .then((res) => {
        if (res.data.success) {
          toast(res.data.msg, { type: "success" });
        } else if (!res.data.success) {
          toast(res.data.err, { type: "error" });
        }

        this.setState({ tag_update_profile: 0 });
        if (this.state.tags.length > 2) {
          this.setState({ tag_update_profile: 20 });
        }
        this.fetchCoachData();
        this.profileUpdateStatus();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSubmitUserName = (e) => {
    e.preventDefault();
    const formData = {
      user_title: this.state.user_title,
      name: this.state.name,
      coaching_category: this.state.coachingCategory,
      // coaching_category: this.state.coaching_category_list,
    };

    let param;

    param = {
      url: "/users/username",
      method: "PUT",
      data: formData,
      headers: {
        "X-Auth": this.token,
      },
    };

    axios(param)
      .then((response) => {
        this.fetchUserName();
        toast("Details updated", { type: "success" });
      })
      .catch((error) => {
        console.log("update error");
        console.log(error);
        toast("Error in updating details", { type: "error" });
      });
  };

  handleSubmitPersonal = (e, Data) => {
    console.log("Data-----9", Data)
    e.preventDefault()
    if (this.state.short_bio && this.state.short_bio.split(" ").length > 50) {
      toast("Word limit exceeded for short bio", {
        type: "error",
      });
    } else {
      const addressData = {
        country: this.state.country,
        city: this.state.city,
        location: this.state.location,
      };

      const formData = {
        user_title: this.state.user_title,
        name: this.state.name,
        coaching_category: this.state.coachingCategory,
        Uid: this.state.coachprofile_id,

        address: JSON.stringify(addressData),
        short_bio: this.state.short_bio,
        coach_uid: this.state.coach_uid,
        long_bio: this.state.long_bio,
        skills: JSON.stringify(this.state.chartValue),
        language: this.state.language,
        timezone: this.state.timezone,
        HoursofExp: this.state.HoursofExp,
        HourlyRate: this.state.HourlyRate,
        membership: this.state.membership,
        tags: this.state.tags,
        SocialMediaInfo: Data !== undefined ? Data : this.state.SocialMediaInfo
      }

      axios.post('/users/coachprofile-edit', formData, {
        headers: { 'x-auth': this.token }
      })
        .then(res => {
          if (res.data.success) {
            const rawdata = res.data.profilePost;
            this.setState({
              short_bio: rawdata.short_bio,
              SocialMedia: JSON.parse(rawdata.social_media)
            })

            toast("Sucessfully updated profile details", { type: "success" });

          }
          this.setState({
            short_bio_update_profile: 0,
          });

          if (this.state.short_bio.length > 5) {
            this.setState({
              short_bio_update_profile: 20,
            });
          }

          this.setState({
            user_title_update_profile: 0,
          });
          if (this.state.user_title && this.state.user_title.length > 0) {
            this.setState({
              user_title_update_profile: 20,
            });
          }

          this.profileUpdateStatus();
          console.log("---------personal--res------", res)
        })
        .catch((error) => {
          console.log(error);
          toast("Error in updating details", {
            type: "error",
          });
        });
    }
  }


  publicprofiletoggle = (value) => {
    console.log('value', value);

    let totalupdate = this.state.totalprofileupdate;
    console.log('totalupdate', totalupdate)
    if (totalupdate === null || totalupdate === undefined) return;
    if (totalupdate < 80) {
      toast("Please complete your profile first", { type: "error" });
      return
    }

    if (totalupdate >= 80) {
      //call api to toggle change public visibility;
      this.togglepublicprofile(value)
    }

    this.setState({ public_profile_toggle: !value })
  }

  togglepublicprofile = (value) => {

    const formData = {
      value: value === false ? 1 : 0
    }



    axios.post('/users/togglepublicprofile', formData, {
      headers: { 'x-auth': this.token }
    })
      .then(res => {
        console.log('togglepublicprofile res', res)
        if (res.data.success) {
          toast("Sucessfully updated public profile status", { type: "success" });
        }
      })
      .catch((error) => {
        console.log(error);
        toast("Error in updating public profile status", {
          type: "error",
        });
      });
  }

  render() {
    // console.clear()

    const {
      avatar_path,
      name,
      coaching_category,
      city,
      email,
      country,
      short_bio,
      tags,
      timezone,
      user_title,
      eligibleForContact
    } = this.state;
//console.log('dddddddddddddddd',coaching_category)
    var subComponentContent;
    if (this.state.renderSubComponent === "Home") {
      subComponentContent = (
        <Home
          token={this.token}
          account_type={this.userdata.account_type}
          // tags={tags}
          tags={tags =="" ? this.state.coachSettings.tag : tags}
          handleUpdateTags={this.handleUpdateTags}
          packagefound={this.packagefound}
          convertToCurrency={this.state.convertToCurrency}
          coaching_category={coaching_category}
          findcurrency={this.state.findcurrency}
          baseCurrency={this.state.baseCurrency}
          check_account_type={this.state.check_account_type}
          userdata={this.userdata}
          uid={this.userdata.uid}
          videofile={this.state.videofile}
          processed={this.state.processed}
          coachName={this.state.name}
          coachEmail={this.state.coachEmail}
          coachUid={this.state.coachUid}
          Consumer_uid={this.state.Consumer_uid}
          Consumer_name={this.state.Consumer_name}
          Consumer_email={this.state.Consumer_email}
          coachImage={this.state.avatar_path}
          coachData={this.state}
          // ConsumerD={this.props.hasOwnProperty('location')?this.props.location.state.ConsumerD : ''}
          ConsumerD={this.state.userd}


          publicView={false}

        />
      );
    } else if (this.state.renderSubComponent === "Bio") {
      subComponentContent = (
        <Bio
          logoImg={this.state.logoview}
          pdata={this.state}
          token={this.token}
          handleChange={this.handleChange}
          handleSubmitPersonal={this.handleSubmitPersonal}
          handleOnChange={this.handleOnChange}
          check_account_type={this.state.check_account_type}
          userdata={this.userdata}
        />
      );
    } else if (this.state.renderSubComponent === "Resources") {
      subComponentContent = (
        <Resources
          token={this.token}
          handleSubmit={this.handleResourceSubmit}
          data={this.state}
          handlegetProfileVideo={this.handlegetProfileVideo}
          handlegetProfileImage={this.handlegetProfileImage}
          check_account_type={this.state.check_account_type}
          userdata={this.userdata}
        />
      );
    } else if (this.state.renderSubComponent === "Contacts") {
      subComponentContent = (
        <Contact
          email={email}
          token={this.token}
          check_account_type={this.state.check_account_type}
        />
      );
    } else if (this.state.renderSubComponent === "Testimonial") {
      subComponentContent = (
        <Testimonial
          token={this.token}
          chartValue={this.state.chartValue}
          handleChangeMultiSkills={this.handleChangeMultiSkills}
          labels_data={this.state.labels_data}
          data_data={this.state.data_data}
          color_data={this.state.color_data}
          handleSubmitSkill={this.handleSubmitSkill}
          check_account_type={this.state.check_account_type}
          coach_uid={this.state.coach_uid}
        />
      );
    } else if (this.state.renderSubComponent === "Blog") {
      subComponentContent = (
        <Blog check_account_type={this.state.check_account_type} blog_id={this.state.blog_id}/>
      );
    }

    return (
      <React.Fragment>
        {/* { this.token  } */}
        {/* <HeaderTop /> */}

        {localStorage.getItem("authToken") == null ? (
          <HeaderTop />
        ) : (
            <HeaderLogout
              currencies={this.state.currencies}
              convertToCurrency={this.state.convertToCurrency}
              changeConvertToCurrency={this.changeConvertToCurrency}
            />
          )}

        <Header />
        {/* <CommunicationUsers avatar_path={
          // "data:image/jpeg;base64,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"
          this.state.coachprofileimage
        }></CommunicationUsers> */}





        <section className="coachsProfileWrap">
          <div className="container">
            <div className="row align-items-start">


              <div className="col-lg-3 col-md-5 col-sm-5 pro_img_block">
                <div className="f_sidebar">
                  <div className="coachImg">
                    {this.state.check_account_type === "coach" ? (
                      <div className="freeTrialDays">
                        <button
                          type="button"
                          className={`btn ${this.state.freeTrialDaysleft < 30
                            ? "btn-danger"
                            : "btn-secondary"
                            } btn-circle btn-xl`}
                        >
                          {this.state.freeTrialDaysleft + " "}
                          <span>
                            days of <br /> free trial remaining
        </span>
                        </button>
                      </div>
                    ) : (
                        ""
                      )}
                    <img src={avatar_path} alt="LG-Img" className="img-fluid" />
                    {/* {this.state.check_account_type === "coach" ? (
                      this.state.renderSubComponent === "Home" ? (
                        <UpdateImage
                          avatar={avatar}
                          userImage2={avatar_path}
                          onChangeHandler={this.onChangeHandler}
                          handleSubmitProfileImage={this.handleSubmitProfileImage}
                        />
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}{" "} */}
                  </div>
                  <div className="fs_cont">
                    {this.state.check_account_type === "coach" ? (

                      <div>
                        <small style={{ color: "black" }}>Profile Completeness</small>

                        <ProgressBar
                          now={this.state.totalprofileupdate}
                          label={`${this.state.totalprofileupdate}%`}
                          // data-toggle="tooltip"
                          // data-placement="top"
                          title={`Your Profile is ${this.state.totalprofileupdate}% completed`}
                        />
                        {this.state.totalprofileupdate > 79 ? "" :
                          <p style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>
                            Complete your profile at least 80%
                          </p>
                        }
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.check_account_type === "coach"?(<>

                  {this.state.isApproved == 1 && this.state.totalprofileupdate > 79 ? (

                    <div>
                      <Row style={{ color: 'black', marginTop: '10px' }} className="justify-content-between ml-0 mr-0">
                        <strong>
                          Make your profile public
                        </strong>

                        <ToggleButton
                          value={this.state.public_profile_toggle || false}
                          onToggle={(value) => this.publicprofiletoggle(value)}
                        // onToggle={(value) => {
                        //   this.setState({
                        //     public_profile_toggle: !value,
                        //   })
                        // }} 
                        />

                      </Row>

                    </div>

                    // Different labels example...
                  ) : (
                      <div>
                        {this.state.totalprofileupdate > 79 ?
                          <p style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>Pending Approval</p>
                          : ""}
                      </div>

                    )}

                    </>):(<></>)}
                  </div>
                </div>
              </div>

              <div className="col-lg-9 col-md-7 col-sm-7">
                {this.state.check_account_type === "coach" &&
                  this.state.freeTrialDaysleft == 0 ? (
                    <div className="freetrial-over mb-4">
                      <span>
                        Your 90 days free trial is over and account has been
                      deactivated.{" "}
                      </span>
                      <br></br>
                      <span>
                        Please
                      <Link
                          to={{
                            pathname: "/price_table",
                            state: {
                              user_t: this.userdata.uid,
                            },
                          }}
                        >
                          {" "}
                        pay here{" "}
                        </Link>
                      to activate your account
                    </span>
                    </div>
                  ) : (
                    <div></div>
                  )}

                <div className="coachInfoWrap">
                  <div className="coachInfo">
                    <div className="cDetails">
                      <h3>
                        {name} {""}
                        {/* {this.state.check_account_type === "coach" ? (
                          this.state.renderSubComponent === "Home" ? (
                            <UpdateUserName
                              name={this.state.name}
                              handleChange={this.handleChange}
                              handleSubmitUserName={this.handleSubmitUserName}
                              handleCategoryChange={this.handleCategoryChange}
                              pdata={this.state}
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )} */}
                      </h3>
                      <h4> {user_title}</h4>
                      <h5>
                        
                        {console.log('cooooooooooooooo',user_title)}
                        {this.state.coachingCategory &&
                          this.state.coachingCategory.map((category) => {
                            return (
                              <span className="badge badge-light even-larger-badge">
                                {" "}
                                {category.value}
                              </span>
                            );
                          })}
                          
                        <UpdateCategory
                          pdata={this.state}
                          handleSubmitPersonal={this.handleSubmitPersonal}
                          handleCategoryChange={this.handleCategoryChange}
                        />
                      </h5>
                    </div>
                    <div className="contactDetails">
                      <p style={{ display: "none" }}>
                        <img width="20px" alt="LG-Img" src={mailSvg} />
                        {email}
                      </p>
                      {/* {this.state.membership && (
                        <p>
                        <img
                          width="25px"
                          alt="LG-Img"
                          src={quality}
                        />
                        Membership of Professional<br/>Association
                      </p>
                      )} */}
                      {this.state.membership && this.state.membership == "1" ? (
                        <p>
                        <img
                          width="25px"
                          alt="LG-Img"
                          src={quality}
                        />
                        Membership of Professional<br/>Association
                      </p>
                      ) : (<p></p>)}

                      {city && this.state.city_public == "1" ? (
                        <p>
                          <img
                            width="20px"
                            alt="LG-Img"
                            src={profileAddressSvg}
                          />
                          {city}
                        </p>
                      ): (<p></p>)}
                      {country && (
                        <p>
                          <img width="20px" alt="LG-Img" src={flagSvg} />{" "}
                          {country}
                        </p>
                      )}
                      {timezone && (
                        <p>
                          <img width="20px" alt="LG-Img" src={clockSvg} />{" "}
                          {timezone}
                        </p>
                      )}
                    </div>
                    <p>{short_bio && short_bio}</p>
                  </div>

                  <ul className="coach_public_tabs">
                    <li
                      className={`${this.state.renderSubComponent === "Home"
                        ? "active"
                        : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Home")}
                      >
                        <i className="fa fa-home" aria-hidden="true"></i> HOME
                      </Link>
                    </li>

                    <li
                      className={`${this.state.renderSubComponent === "Bio" ? "active" : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Bio")}
                      >
                        <i className="fa fa-info" aria-hidden="true"></i> BIO
                      </Link>
                    </li>

                    <li
                      className={`${this.state.renderSubComponent === "Resources"
                        ? "active"
                        : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Resources")}
                      >
                        <i className="fa fa-camera" aria-hidden="true"></i>
                        RESOURCES
                      </Link>
                    </li>
                    {eligibleForContact ? (
                      <li
                      className={`${this.state.renderSubComponent === "Contacts"
                        ? "active"
                        : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Contacts")}
                      >
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        CONTACT
                      </Link>
                    </li>
                    ) : ''}
                    

                    <li
                      className={`${this.state.renderSubComponent === "Testimonial"
                        ? "active"
                        : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Testimonial")}
                      >
                        <i className="fa fa-comments-o" aria-hidden="true"></i>
                        TESTIMONIALS
                      </Link>
                    </li>
                    <li
                      className={`${this.state.renderSubComponent === "Blog"
                        ? "active"
                        : " "
                        }`}
                    >
                      <Link
                        to={
                          this.state.check_account_type === "coach"
                            ? "/profile-coach"
                            : `/profile-coach-view/${this.state.Public_view_uid}`
                        }
                        onClick={() => this.handleSubComponent("Blog")}
                      >
                        <i className="fa fa-th-large" aria-hidden="true"></i>
                        BLOG
                      </Link>
                    </li>
                  </ul>
                  {/* <div style={{ position: "absolute", right: "20px", top: 0 }}>
                    {this.state.check_account_type === "coach" ? (
                      this.state.renderSubComponent === "Home" ? (
                        <UpdatePersonal
                          pdata={this.state}
                          handleChange={this.handleChange}
                          handleSubmit={this.handleSubmit}
                          handleAddressSelected={this.handleAddressSelected}
                          handleCheckbox={this.handleCheckbox}
                          handleLanguageChange={this.handleLanguageChange}

                          avatar={avatar}
                          userImage2={avatar_path}
                          onChangeHandler={this.onChangeHandler}
                          handleSubmitProfileImage={this.handleSubmitProfileImage}

                          handleCategoryChange={this.handleCategoryChange}

                          handleSubmitPersonal={this.handleSubmitPersonal}
                        />
                      ) : (
                          ""
                        )
                    ) : (
                        <Link to="profile-consumer">
                          <button className="btn btn-sm btn-info">Back</button>
                        </Link>
                      )}
                  </div> */}
                  {/* <div style={{ position: "absolute", right: "20px", top: 0 }}>
                    {this.state.check_account_type === "coach" ? (
                      this.state.renderSubComponent === "Home" ? (
                        <div className="edit_personal_details">
                          <Link
                            to="profile-coach-edit"
                            
                            data-toggle="tooltip"
                            
                            title="Update you Profile"
                          
                          >
                            <img width="40px" src={writingSvg} alt="LG-Img" />
                          </Link>
                        </div>
                      ) : (
                          ""
                        )
                    ) : (
                        <Link to="profile-consumer">
                          <button className="btn btn-sm btn-info">Back</button>
                        </Link>
                      )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {subComponentContent}

        <FooterLink />
      </React.Fragment>
    );
  }
}

export default CoachProfilePrivate;
